import {
  Autocomplete,
  SelectProps,
  TextField,
  TextFieldVariants,
} from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import React from "react";
interface AutoDropDownRequiredProps {
  codes: string[];
  elementId: string;
  value: string;
}

interface AutoDropDownOptionalProps {
  defaultValue?: string;
  disable?: boolean;
  required?: boolean;
  variant?: TextFieldVariants;
  sx?: SxProps<Theme>;
  label?: string;
  name?: string;
  // Note: Autocomplete passes the string value directly instead of a native input event
  onChange?: any;
  className?: string;
  inputProps?: Partial<SelectProps["inputProps"]>;
  defaultOption?: string;
}

interface AutoDropDownProps
  extends AutoDropDownRequiredProps, AutoDropDownOptionalProps {}

export const AutoDropDown: React.FC<AutoDropDownProps> = ({
  codes = [],
  elementId,
  disable = false,
  required = false,
  variant,
  sx = {},
  label = "",
  className = "form-control",
  name = "",
  onChange,
  inputProps = {},
  value,
  defaultOption = "",
}) => {
  // Combine your default blank option and data codes into a single list for the search menu
  const finalOptions = defaultOption ? [defaultOption, ...codes] : codes;

  return (
    <Autocomplete
      id={elementId}
      disabled={disable}
      options={finalOptions}
      value={
        value !== undefined && value !== "null" && value !== ""
          ? value
          : defaultOption || null
      }
      onChange={(event, newValue) => {
        if (onChange) onChange(event, newValue);
      }}
      sx={{
        "& .MuiInputBase-root": {
          backgroundColor: "#ffffff",
        },
        ...sx,
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          className={className}
          label={label}
          name={name}
          required={required}
          variant={variant}
          type="text"
          SelectProps={{
            native: true,
          }}
          inputProps={{
            ...params.inputProps,
            ...inputProps,
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
            shrink: true,
          }}
        />
      )}
    />
  );
};
